/**
 * Pure stepper functions for the sell panel quantity selector.
 *
 * The +/- buttons step in pack-size increments, but the final step
 * snaps to the actual max (which may not be a multiple of packSize).
 *
 * Example with max=18, packSize=5:
 *   Stepping up:   0 -> 5 -> 10 -> 15 -> 18
 *   Stepping down: 18 -> 15 -> 10 -> 5 -> 0
 */

/** Step the sell quantity up by one pack, clamping to max. */
export function nextSellStep(current: number, packSize: number, max: number): number {
	return Math.min(current + packSize, max);
}

/** Step the sell quantity down by one pack, snapping to the nearest lower pack-size multiple. */
export function prevSellStep(current: number, packSize: number, _max: number): number {
	if (current <= 0) return 0;
	return Math.max(Math.floor((current - 1) / packSize) * packSize, 0);
}
